import { captureException } from '@sentry/node';
import axios from 'axios';
import get from 'lodash/get';

const baseURL = `${process.env.NEXT_PUBLIC_WAVE_HOSTNAME}`;

export async function sendMail(formData) {
  try {
    if (!formData) {
      throw Error('Request failed, no data given.');
    }

    const response = await axios.post(`${baseURL}/api/v2/proxies/mailer`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        appId: process.env.appId,
      },
    });
    if (response.status !== 200) {
      throw Error('Request failed');
    }
    return {};
  } catch (requestError) {
    captureException(error);
    const error = get(requestError, 'response.data.error', {});
    return { error };
  }
}
